import { createApp } from "vue";

import PrimeVue from "primevue/config";

import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import { focusDirective, clickOutsideDirective } from "./directives";

import store from "./store";
import router from "./router";
import VueAgile from "vue-agile";
import i18n from "./plugins/i18n";
import uValue from "./plugins/u-value";
import PrimeVueLocalConfigs from "./configs/primevue";
import VueImageZoomer from "vue-image-zoomer";

import PVueRow from "primevue/row";
import PVueMenu from "primevue/menu";
import PVueBadge from "primevue/badge";
import PVuePanel from "primevue/panel";
import PVueColumn from "primevue/column";
import PVueButton from "primevue/button";
import PVueDialog from "primevue/dialog";
import PVueEditor from "primevue/editor";
import PCarousel from "primevue/carousel";
import PVueSidebar from "primevue/sidebar";
import PVueTabView from "primevue/tabview";
import PVueRadio from "primevue/radiobutton";
import PVueCalendar from "primevue/calendar";
import PVueTabPanel from "primevue/tabpanel";
import PVueFieldset from "primevue/fieldset";
import PVueDropdown from "primevue/dropdown";
import PVueSkeleton from "primevue/skeleton";
import PVuePassword from "primevue/password";
import PVueTextArea from "primevue/textarea";
import PVueCheckbox from "primevue/checkbox";
import PVueDataTable from "primevue/datatable";
import PVueOrderList from "primevue/orderlist";
import PVueInputText from "primevue/inputtext";
import PVueFileUpload from "primevue/fileupload";
import PVueInputNumber from "primevue/inputnumber";
import PVueColumnGroup from "primevue/columngroup";
import PVueSelectButton from "primevue/selectbutton";
import PVueConfirmPopup from "primevue/confirmpopup";
import PVueConfirmDialog from "primevue/confirmdialog";

import PVueBadgeDirective from "primevue/badgedirective";

import App from "./App";

import IIcon from "./components/interface/i-icon";
import IPage from "./components/interface/i-page";
import IImg from "./components/interface/i-img";
import IBanner from "./components/interface/i-banner";
import ILoading from "./components/interface/i-loading";
import IContainer from "./components/interface/i-container";
import IFormError from "./components/interface/i-form-error";
import IInputPhone from "./components/interface/i-input-phone";
import IPlusButton from "./components/interface/i-plus-button";
import IPageContent from "./components/interface/i-page-content";
import ISmoothPicker from "./components/interface/i-smooth-picker";
import ILinerHeading from "./components/interface/i-liner-heading";
import IDateDropdown from "./components/interface/i-date-dropdown";
import IContactsGroup from "./components/interface/i-contacts-group";
import IOverrideDialog from "./components/interface/i-override-dialog";
import IAttachemntsList from "./components/interface/i-attachments-list";
import IOverrideCalendar from "./components/interface/i-override-calendar";
import IOverrideDropdown from "./components/interface/i-override-dropdown";
import ICustomizedCalendar from "./components/interface/i-customized-calendar";
import IOverrideSelectButton from "./components/interface/i-override-select-button";

import "./cordova-script";

import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "vue-image-zoomer/dist/style.css";

import "./assets/primevue-apoint-rtl.css?v=24122023";
import "./assets/style.css";
import "./assets/styles/main.scss";

import "./registerServiceWorker";
import { VueCookieNext } from "vue-cookie-next";
import { appUpdateRequired } from "./services/APointAPI";

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

document.addEventListener("deviceready", () => {
  appUpdateRequired().then((ans) => {
    // console.log("appUpdateRequied then", ans);
    // console.log("ans.UpdateRequired", JSON.parse(ans).UpdateRequired);
    let updateRequired = JSON.parse(ans).UpdateRequired;
    // updateRequired = true
    if (updateRequired) {
      // console.log("in ans.UpdateRequired");
      window.navigator?.splashscreen?.show();
      if (window.CacheClear)
        window.CacheClear(() => {
          // alert(status)
          // לשמור בקוקי מתי נעשה ריענון ושלא יעשה יותר מפעם ב 10 דקות
          let lastReload = new Date(VueCookieNext.getCookie("lastReload"));
          lastReload.setMinutes(lastReload.getMinutes() + 10);
          if (lastReload < new Date()) {
            VueCookieNext.setCookie("lastReload", new Date());
            // window.location.reload();
          }
          // console.log("CacheClear success: ", status);
        });
    }
  });
});

document.addEventListener("deviceready", () => {
  // if (window.cordova.platformId === "browser") {
  //   window.navigator.splashscreen.hide();
  // }
  const app = createApp(App);
  app
    .use(store)
    .use(router)
    .use(uValue)
    .use(i18n, { local: "en" })
    .use(PrimeVue, PrimeVueLocalConfigs)
    .use(VueCookieNext)
    .use(ToastService)
    .use(ConfirmationService)
    .use(VueAgile)
    .use(VueImageZoomer)
    .directive("badge", PVueBadgeDirective)
    .mount("#app");

  //Register global directives
  app.directive("focus", focusDirective);
  app.directive("click-outside", clickOutsideDirective);

  app.component("p-vue-row", PVueRow);
  app.component("p-vue-menu", PVueMenu);
  app.component("p-vue-panel", PVuePanel);
  app.component("p-vue-badge", PVueBadge);
  app.component("p-vue-radio", PVueRadio);
  app.component("p-vue-button", PVueButton);
  app.component("p-vue-dialog", PVueDialog);
  app.component("p-vue-column", PVueColumn);
  app.component("p-vue-carousel", PCarousel);
  app.component("p-vue-sidebar", PVueSidebar);
  app.component("p-vue-table", PVueDataTable);
  app.component("p-vue-editor", PVueEditor);
  app.component("p-vue-tab-view", PVueTabView);
  app.component("p-vue-password", PVuePassword);
  app.component("p-vue-dropdown", PVueDropdown);
  app.component("p-vue-fieldset", PVueFieldset);
  app.component("p-vue-skeleton", PVueSkeleton);
  app.component("p-vue-textarea", PVueTextArea);
  app.component("p-vue-calendar", PVueCalendar);
  app.component("p-vue-checkbox", PVueCheckbox);
  app.component("p-vue-tab-panel", PVueTabPanel);
  app.component("p-vue-order-list", PVueOrderList);
  app.component("p-vue-input-text", PVueInputText);
  app.component("p-vue-file-upload", PVueFileUpload);
  app.component("p-vue-column-group", PVueColumnGroup);
  app.component("p-vue-input-number", PVueInputNumber);
  app.component("p-vue-confirm-popup", PVueConfirmPopup);
  app.component("p-vue-confirm-dialog", PVueConfirmDialog);
  app.component("p-vue-select-button", PVueSelectButton);

  app.component("i-img", IImg);
  app.component("i-icon", IIcon);
  app.component("i-page", IPage);
  app.component("i-banner", IBanner);
  app.component("i-loading", ILoading);
  app.component("i-container", IContainer);
  app.component("i-form-error", IFormError);
  app.component("i-plus-button", IPlusButton);
  app.component("i-input-phone", IInputPhone);
  app.component("i-page-content", IPageContent);
  app.component("i-smooth-picker", ISmoothPicker);
  app.component("i-liner-heading", ILinerHeading);
  app.component("i-date-dropdown", IDateDropdown);
  app.component("i-contacts-group", IContactsGroup);
  app.component("i-override-dialog", IOverrideDialog);
  app.component("i-attachments-list", IAttachemntsList);
  app.component("i-override-calendar", IOverrideCalendar);
  app.component("i-override-dropdown", IOverrideDropdown);
  app.component("i-customized-calendar", ICustomizedCalendar);
  app.component("i-override-select-button", IOverrideSelectButton);
});
